import type { DateRange } from 'react-day-picker'

import { type FvDateInput, fvDate, fvDateUtc } from '@fv/dates'

export function toLocalCalendarDateFromUtc(date?: FvDateInput) {
  if (!date) return undefined
  return fvDate(fvDateUtc(date).format('YYYY-MM-DD')).toDate()
}

export function toDatePickerRange(
  start?: FvDateInput,
  end?: FvDateInput,
): DateRange {
  return {
    from: toLocalCalendarDateFromUtc(start),
    to: toLocalCalendarDateFromUtc(end),
  }
}

export function hasCompleteDateRange(
  range?: DateRange,
): range is Required<Pick<DateRange, 'from' | 'to'>> {
  return !!range?.from && !!range.to
}

export function getUtcDayRangeParam(range?: DateRange) {
  if (!hasCompleteDateRange(range)) return null

  const startTime = fvDateUtc(fvDate(range.from).format('YYYY-MM-DD'))
    .startOf('day')
    .valueOf()
  const endTime = fvDateUtc(fvDate(range.to).format('YYYY-MM-DD'))
    .endOf('day')
    .valueOf()

  return `${startTime}-${endTime}`
}
